import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { westLinnConfig } from "./data";

export default function WestLinnPage() {
  return <OregonCityPageTemplate config={westLinnConfig} />;
}